import { Head, usePage } from "@inertiajs/react"

import HeadingSmall from "@/components/heading-small"
import { Avatar } from "@/components/ui/avatar"
import { AvatarImage } from "@/components/ui/avatar"
import { AvatarFallback } from "@/components/ui/avatar"
import AdminSettingsLayout from "@/layouts/admin/settings-layout"
import AdminLayout from "@/layouts/admin-layout"
import { adminSettingsUsersPath } from "@/routes"
import type { Account, Admin, BreadcrumbItem } from "@/types"

const breadcrumbs: BreadcrumbItem[] = [
  {
    title: "Members",
    href: adminSettingsUsersPath(),
  },
]

export default function Account() {
  const { admins } = usePage<{ admins: Admin[] }>().props as { admins: Admin[] }

  const userRows = admins.map((admin) => (
    <div key={admin.id} className="flex items-center gap-4 py-3">
      <Avatar className="h-8 w-8 overflow-hidden rounded-full">
        <AvatarImage src={admin.avatar_url} alt={admin.name} />
        <AvatarFallback className="rounded-lg bg-neutral-200 text-black dark:bg-neutral-700 dark:text-white">
          {admin.avatar_initials}
        </AvatarFallback>
      </Avatar>
      <div>
        <div className="font-medium">{admin.name}</div>
        <div className="flex items-center gap-2">
          <div className="text-muted-foreground text-sm">{admin.email}</div>
        </div>
      </div>
    </div>
  ))
  return (
    <AdminLayout breadcrumbs={breadcrumbs}>
      <Head title={breadcrumbs[breadcrumbs.length - 1].title} />

      <AdminSettingsLayout>
        <div className="space-y-2">
          <HeadingSmall title="Members" />
          <div className="divide-y divide-gray-200">{userRows}</div>
        </div>
      </AdminSettingsLayout>
    </AdminLayout>
  )
}
